import React from "react";
import { Col, Collapse, Row, Typography } from "antd";
import moment from "moment-jalaali";
import { convertNumToFa, getDateString } from "../../constant/helper";

const { Panel } = Collapse;
const { Paragraph } = Typography;

const MessageItem = (props) => {
  const { item } = props;

  return (
    <Collapse accordion={true} ghost bordered={false} expandIcon={false}>
      <Panel
        key={item.id}
        showArrow={false}
        className="message-wrapper"
        header={
          <Row className="message">
            <Col flex="auto" className="">
              <Row align="middle">
                <Col className="info" flex="auto">
                  <Paragraph ellipsis>{item.title}</Paragraph>
                </Col>
              </Row>
            </Col>
            <Col className="date-time">
              <div className="date">
                {convertNumToFa(getDateString(item.createdDate))}
              </div>
              <div className="time">
                {convertNumToFa(moment(item.createdDate).format("HH:mm"))}
              </div>
            </Col>
          </Row>
        }
      >
        <div className="expanded-log">{item.message}</div>
      </Panel>
    </Collapse>
  );
};

export default MessageItem;
